import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-139e50d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "_wrap" }
const _hoisted_2 = { class: "wrap_row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "_sm_icon_text" }, "公众号", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "_sm_icon_text" }, "今日头条", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "_sm_icon_text" }, "知乎", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "_sm_icon_text" }, "尽管问", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "_sm_icon_text" }, "华美云", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "_sm_icon_text" }, "查酒店", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "_sm_icon_text" }, "品牌墙", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "_sm_icon_text" }, "环酒历", -1))
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "_sm_icon",
        style: _normalizeStyle(_ctx.iconSize),
        id: "wechat",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showQR('wechat'))),
        target: "_blank"
      }, _hoisted_4, 4),
      _createElementVNode("a", {
        class: "_sm_icon",
        style: _normalizeStyle(_ctx.iconSize),
        id: "toutiao",
        href: "https://www.toutiao.com/c/user/token/MS4wLjABAAAAISKFxmYVnp9JkbKrkY-4RzFFgdcq_flX1RSEUId-U_dVDUn5p3U0EkLkJmC2OUhp/?",
        target: "_blank"
      }, _hoisted_6, 4),
      _createElementVNode("a", {
        class: "_sm_icon",
        style: _normalizeStyle(_ctx.iconSize),
        id: "zhihu",
        href: "https://www.zhihu.com/org/hua-mei-gu-wen-24",
        target: "_blank"
      }, _hoisted_8, 4),
      _createElementVNode("a", {
        class: "_sm_icon",
        style: _normalizeStyle(_ctx.iconSize),
        id: "jgw",
        href: "https://hotelmgmt.jinguanwen.com",
        target: "_blank"
      }, _hoisted_10, 4),
      _createElementVNode("a", {
        class: "_sm_icon noinvert",
        style: _normalizeStyle(_ctx.iconSize),
        id: "hmy",
        href: "https://c.huamei2001.com",
        target: "_blank"
      }, _hoisted_12, 4),
      _createElementVNode("a", {
        class: "_sm_icon noinvert",
        style: _normalizeStyle(_ctx.iconSize),
        id: "cjd",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showQR('cjd')))
      }, _hoisted_14, 4),
      _createElementVNode("a", {
        class: "_sm_icon noinvert",
        style: _normalizeStyle(_ctx.iconSize),
        id: "ppq",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showQR('ppq')))
      }, _hoisted_16, 4),
      _createElementVNode("a", {
        class: "_sm_icon noinvert",
        style: _normalizeStyle(_ctx.iconSize),
        id: "hjl",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showQR('hjl')))
      }, _hoisted_18, 4)
    ])
  ]))
}